<template>
    <div class="column-layout clearfix" style="height: 100%;">
        <div v-cloak class="left-column fl" :class="{'active' : !treeCollapse}">
            <div class="tab-container base">
                <div class="tabs-nav">
                    <ul class="head">
                        <li class="head-item current">组织机构</li>
                    </ul>
                </div>
            </div>
            <div id="tree-menu">
                <swb-org-tree :bizUnitId="bizUnitId" :enableSearch="true" :bizDepart="true" @notity-change="notityChange($event)" @show-tree-collapse="showTreeCollapse($event)"></swb-org-tree>
            </div>
        </div>
        <div class="right-column fl" style="height: 100%;">
            <div class="simple-row" style="background-color: #fafafa;line-height: 49px;height: 49px;" v-if="showSaveBth">
                <button @click="saveStaffRole();" style="float: right;margin-top: 8px;" class='swb-btn swb-btn-small mr15'>
                    <span>保存</span>
                </button>
            </div>
            <div class="table-layout" style="overflow-y: auto;height: calc(100% - 44px);">
                <el-table ref="multipleTable" :data="roleList" border style="width: 100%" @selection-change="handleSelectionChange" row-key="id">
                    <el-table-column :selectable="selectable" align="center" type="selection" width="55"></el-table-column>
                    <el-table-column prop="name" label="岗位名称"></el-table-column>
                    <el-table-column prop="mobAppRoleName" label="移动端功能" width="120">
                        <template slot-scope="rows">
                            <span v-if="rows.row.mobAppRoleName != null">可用</span>
                            <span class="font-red" v-else>不可用</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    //
    import servicerAuthxApi from '../../api/servicerAuthx'
    //
    import SwbOrgTree from '../orgStruct/OrgTree';

    Vue.regist(SwbOrgTree);
    //
    export default {
        name: 'swb-servicer-staff-role-edit',
        desc: '人员岗位配置',
        props: {
            staff: {
                type: Object,
                default: {}
            },
            checkedRoleList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            showSaveBth: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                loading: false,
                roleList: [],
                checkedRoles: [],
                selectedRoleMap: {}, // 多个不同部门下的岗位同时选择的时候使用
                treeCollapse: true,
                multipleSelection: [],
                comId: null,
                bizUnitId: null,
                staffRolesMap: {}
            }
        },
        created: function () {
            //
            this.bizUnitId = this.staff.comId;
            this.comId = this.bizUnitId;
            this.getServicerComRoleList(this.staff.comId);
        },
        methods: {
            getServicerComRoleList: function (comId) {
                let self = this;
                let postData = {};
                postData.comId = comId;
                servicerAuthxApi.getServicerComRoleList(postData, function (result) {
                    if (result.type === "info") {
                        let data = result.data;
                        self.roleList = Utils.merge([], data);
                        if (!Utils.isNoB(self.staff.id) && self.staff.id > 0) {
                            self.getStaffRoleList();
                        } else {
                            let checkedRoleList = self.checkedRoleList || [];
                            if (!Utils.isNoB(checkedRoleList) && checkedRoleList.length > 0) {
                                self.checkedRoles = Utils.merge([], checkedRoleList.pluck('id'));
                                self.selectedRoleList = Utils.merge([], checkedRoleList);
                                // 回显
                                let list = [];
                                let roleList = self.roleList || [];
                                roleList.forEach(function (item) {
                                    if (self.checkedRoles.indexOf(item.id) >= 0) {
                                        list.push(item);
                                    }
                                });
                                if (list.length > 0) {
                                    list.forEach(row => {
                                        self.$nextTick(function () {
                                            self.$refs.multipleTable.toggleRowSelection(row);
                                        });
                                    });
                                }
                            } else {
                                let selectedRoleMap = self.selectedRoleMap || {};
                                if (!Utils.isNoB(selectedRoleMap)) {
                                    let selectedRoleList = selectedRoleMap[comId] || [];
                                    let checkedRoles = Utils.merge([], selectedRoleList.pluck('id'));
                                    // 回显
                                    let list = [];
                                    let roleList = self.roleList || [];
                                    roleList.forEach(function (item) {
                                        if (checkedRoles.indexOf(item.id) >= 0) {
                                            list.push(item);
                                        }
                                    });
                                    if (list.length > 0) {
                                        list.forEach(row => {
                                            self.$nextTick(function () {
                                                self.$refs.multipleTable.toggleRowSelection(row);
                                            });
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getStaffRoleList: function () {
                let self = this;
                self.checkedRoles = [];
                servicerAuthxApi.getServicerStaffRoleList({staffId: self.staff.id, comId: this.staff.comId}, function (result) {
                    self.loading = false;
                    if (result.type === "info") {
                        let checkedRoles = [];
                        for (let i = 0; i < result.data.length; i++) {
                            let data = result.data[i];
                            checkedRoles.push(data.roleId);
                        }
                        self.checkedRoles = Utils.merge([], checkedRoles);
                        self.staffRolesMap = result.data.toMap('roleId');
                        //
                        let list = [];
                        let roleList = self.roleList || [];
                        roleList.forEach(function (item) {
                            if (checkedRoles.indexOf(item.id) >= 0) {
                                list.push(item);
                            }
                        });
                        if (list.length > 0) {
                            list.forEach(row => {
                                self.$nextTick(function () {
                                    self.$refs.multipleTable.toggleRowSelection(row);
                                });
                            });
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            handleSelectionChange: function (val) {
                let checkedRoles = this.checkedRoles || [];
                let roleList = this.roleList || [];
                let roleIds = roleList.pluck("id");
                let selectIds = [];
                for (let i = roleIds.length - 1; i >= 0; i--) {
                    let roleId = roleIds[i]
                    if (checkedRoles.indexOf(roleId) >= 0) {
                        checkedRoles.remove(roleId);
                    }
                }
                if (val.length > 0) {
                    val.forEach(function (item) {
                        if (checkedRoles.indexOf(item.id) < 0) {
                            selectIds.push(item.id);
                        }
                    })
                }
                if (selectIds.length > 0) {
                    let newCheckedRoles = checkedRoles.concat(selectIds);
                    this.checkedRoles = Utils.merge([], newCheckedRoles);
                } else {
                    this.checkedRoles = Utils.merge([], checkedRoles);
                }
                // 多选的时候每个机构都缓存选中的数据
                let selectedRoleMap = this.selectedRoleMap || {};
                selectedRoleMap[this.comId] = Utils.merge([], val);
                this.selectedRoleMap = Utils.merge({}, selectedRoleMap);
            },
            notityChange(eventData) {
                this.comId = eventData.id;
                this.getServicerComRoleList(eventData.id);
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            saveStaffRole: function () {
                let self = this;
                let checkedRoles = this.checkedRoles || [];
                let postData = {};
                postData.comId = this.staff.comId;
                postData.userId = this.staff.userId;
                postData.roleIds = checkedRoles;
                postData.type = 0;
                servicerAuthxApi.examineStaffRoleChangeCondition(postData, function (result) {
                    let success = result.data;
                    if (result.type === "info" && success) {
                        self.replaceStaffRole(checkedRoles);
                    } else {
                        MsgBox.warning(result.message);
                        selfDlg.loading = false;
                    }
                });
            },
            replaceStaffRole(data) {
                let selfDlg = this;
                let post_data = {};
                post_data.staffId = this.staff.id;
                post_data.comId = this.staff.comId;
                post_data.userId = this.staff.userId;
                post_data.roleIds = data;
                servicerAuthxApi.replaceServicerStaffRole(post_data, function (result) {
                    selfDlg.loading = false;
                    if (result.type === "info") {
                        MsgBox.success("添加成功");
                        selfDlg.getServicerComRoleList(selfDlg.comId);
                    } else {
                        MsgBox.error(result.message);
                    }
                });
            },
            selectable: function (row, index) {
                let staffRole = this.staffRolesMap[row.id];
                if (!Utils.isNoB(staffRole) && staffRole.handoverState == 1) {
                    return false;
                }
                return true;
            },
            // 选中列表返回结果
            getDlgResult: function () {
                let result = {};
                let selectedRoleMap = this.selectedRoleMap || {};
                if (Utils.isNoB(selectedRoleMap)) {
                    result.type = 'warn';
                    result.message = '请至少选择一个岗位';
                } else {
                    let selectedRoleList = [];
                    for (let selectedRoleComId in selectedRoleMap) {
                        let dataList = selectedRoleMap[selectedRoleComId] || [];
                        if (!Utils.isNoB(dataList) && dataList.length > 0) {
                            selectedRoleList = selectedRoleList.concat(dataList);
                        }
                    }
                    if (selectedRoleList.length <= 0) {
                        //
                        result.type = 'warn';
                        result.message = '请至少选择一个岗位';
                    } else {
                        //
                        result.type = 'info';
                        result.data = Utils.merge([], selectedRoleList);
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/StaffRoleList.vue